/* eslint-disable no-useless-escape */
import $ from 'jquery';
import 'owl.carousel';

class MatchmakerSlider {
  init() {
    this.intro = $('.js-intro');
    this.matchmaker = $('.js-matchmaker');
    this.slideInterval = 5000;
    this.pauseOnHover = false;

    this.scrolling = false;
    this.introScrolling = false;
    this.isFirefox = /Firefox/i.test(navigator.userAgent);
    this.isIe =
      /MSIE/i.test(navigator.userAgent) ||
      /Trident.*rv\:11\./i.test(navigator.userAgent);
    this.scrollSensitivitySetting = 30;

    this.initCarousel();
    this.introSection();
  }

  introSection() {
    if (!this.intro.length || !this.matchmaker.length) {
      return;
    }

    this.introButton = this.intro.find('.js-intro-button');
    this.scrollEvents('intro');
    this.touchEvents('intro');

    this.introButton.on('click', e => {
      e.preventDefault();
      this.introScroll();
    });
  }

  introScroll() {
    if (this.introScrolling) {
      return;
    }

    this.introScrolling = true;

    $('.js-front-page')
      .stop()
      .animate(
        {
          scrollTop: this.intro.height(),
        },
        600,
        () => {
          this.intro.hide();
          this.matchmaker.addClass('has-started');

          setTimeout(() => {
            this.matchmaker.addClass('is-init');
          }, 1900);

          if (this.carousel && this.carousel.length) {
            // this.carousel.data('owl.carousel').options.autoplay = true;
            // this.carousel.trigger('refresh.owl.carousel');
            // this.carousel.find('.js-matchmaker-inner-copy').remove();
            this.carousel.trigger('play.owl.autoplay');
            this.scrollEvents();
            this.touchEvents();
          }
        },
      );
  }

  dotsAnimation(matchmaker) {
    const dots = matchmaker.find('.owl-dots');
    const activeDot = dots.length ? dots.find('.owl-dot.active') : '';
    // this.isPaused = false;
    this.dotAnimating = activeDot;
    // this.remainingTime = 4000;

    if (activeDot.length) {
      dots
        .find('.owl-dot')
        .removeClass('is-full')
        .not(activeDot)
        .removeClass('is-animating')
        .find('span')
        .css({ height: '', 'transition-duration': '' });
      activeDot.prevAll().addClass('is-full');

      setTimeout(() => {
        activeDot.addClass('is-animating');
      }, 10);
    }
  }

  dotsPause(matchmaker) {
    this.dotAnimating = matchmaker.find('.owl-dot.active.is-animating');

    if (this.dotAnimating.length) {
      this.dotHeight = this.dotAnimating.find('span').height();
      this.dotPercent = (this.dotHeight * 100) / 60;
      this.remainingTime =
        this.slideInterval - this.slideInterval * (this.dotPercent / 100);

      this.dotAnimating
        .removeClass('is-animating')
        .find('span')
        .css({ height: this.dotHeight });
    }
  }

  dotsPlay() {
    if (this.dotAnimating.hasClass('active')) {
      this.dotAnimating
        .addClass('is-animating')
        .find('span')
        .css({
          height: '',
          'transition-duration': `${this.remainingTime}ms`,
        });
    }
  }

  scrollEvents(action = 'slider') {
    let events = 'scroll wheel DOMMouseScroll mousewheel';

    if (this.isIe) {
      events = 'scroll wheel DOMMouseScroll';
    } else if (this.isFirefox) {
      events = 'scroll mousewheel DOMMouseScroll';
    }

    if (action === 'slider') {
      this.carousel.off(events);
      this.carousel.on(events, e => {
        this.scrollAction(e, action);
      });
    }

    if (action === 'intro') {
      this.intro.off(events);
      this.intro.on(events, e => {
        this.scrollAction(e, action);
      });
    }
  }

  scrollAction(e, action) {
    e.preventDefault();
    let delta;

    if (this.scrolling) {
      return;
    }

    if ($(e.target).closest('.js-google-map-js').length) {
      return;
    }

    if (this.isFirefox) {
      delta = e.originalEvent.detail * -120;
    } else if (this.isIe) {
      delta = -e.originalEvent.deltaY;
    } else {
      delta = e.originalEvent.wheelDelta;
    }

    if (delta !== 0) {
      if (delta > 0 && delta >= this.scrollSensitivitySetting) {
        if (action === 'slider') {
          this.scrollSectionsHandler('up');
        }
      } else if (delta <= -this.scrollSensitivitySetting) {
        if (action === 'slider') {
          this.scrollSectionsHandler('down');
        } else if (action === 'intro') {
          this.introScroll();
        }
      }
    }
  }

  touchEvents(action = 'slider') {
    if (action === 'slider') {
      this.carousel.on('touchstart touchemove dragstart', e => {
        this.startPos = e.pageY || e.originalEvent.changedTouches[0].pageY;
      });

      this.carousel.on('touchend dragend', e => {
        this.touchAction(e, action);
      });
    }

    if (action === 'intro') {
      this.intro.on('touchstart touchemove dragstart', e => {
        this.startPos = e.pageY || e.originalEvent.changedTouches[0].pageY;
      });

      this.intro.on('touchend dragend', e => {
        this.touchAction(e, action);
      });
    }
  }

  touchAction(e, action) {
    if ($(e.target).closest('.js-google-map-js').length) {
      return;
    }

    this.endPos = e.pageY || e.originalEvent.changedTouches[0].pageY;

    if (this.startPos > this.endPos) {
      if (action === 'slider') {
        this.scrollSectionsHandler('down');
      } else if (action === 'intro') {
        this.introScroll();
      }
    } else if (this.startPos < this.endPos) {
      if (action === 'slider') {
        this.scrollSectionsHandler('up');
      }
    }
  }

  scrollSectionsHandler(direction) {
    this.dir = direction;

    if (!this.scrolling) {
      this.scrolling = true;

      this.carousel.addClass('has-no-autoplay').removeClass('has-autoplay');
      this.carousel.trigger('stop.owl.autoplay');

      if (this.dir === 'down') {
        this.carousel.trigger('next.owl.carousel');
      }
      if (this.dir === 'up') {
        this.carousel.trigger('prev.owl.carousel');
      }
    }
  }

  initCarousel() {
    if (!this.matchmaker.length) {
      return;
    }

    this.matchmaker.each((i, el) => {
      const matchmaker = $(el);

      if (matchmaker.hasClass('js-matchmaker-single')) {
        matchmaker.addClass('has-loaded');
      }

      if (!matchmaker.hasClass('owl-carousel')) {
        return;
      }

      matchmaker.on('initialized.owl.carousel', () => {
        setTimeout(() => {
          this.dotsAnimation(matchmaker);
          matchmaker.trigger('stop.owl.autoplay');
        }, 100);
      });

      this.carousel = matchmaker.owlCarousel({
        items: 1,
        dots: true,
        nav: false,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        mouseDrag: false,
        touchDrag: false,
        dotsSpeed: 100,
        loop: true,
        autoplay: false,
        autoplayTimeout: this.slideInterval,
        autoplayHoverPause: this.pauseOnHover,
      });

      if (this.pauseOnHover) {
        this.isPaused = false;

        matchmaker.on('mouseover.owl.autoplay', () => {
          if (this.pauseOnHover && !this.isPaused) {
            this.dotsPause(matchmaker);
            this.isPaused = true;
          }
        });

        matchmaker.on('mouseleave.owl.autoplay', () => {
          if (this.pauseOnHover && this.isPaused) {
            this.dotsPlay();
            this.isPaused = false;
          }
        });
      }

      matchmaker.on('translated.owl.carousel', () => {
        this.scrolling = false;
      });

      // make slide copy on change
      matchmaker.on('change.owl.carousel', e => {
        this.prev = matchmaker.find('.owl-item').eq(e.item.index);
        matchmaker.find('.js-matchmaker-inner-copy').remove();
      });

      matchmaker.on('changed.owl.carousel', e => {
        const active = matchmaker.find('.owl-item').eq(e.item.index);
        matchmaker.removeClass('is-init');

        if (active.find('.is-entry').length) {
          matchmaker.addClass('has-entry-active');
          setTimeout(() => {
            this.matchmaker.addClass('is-init');
          }, 1900);
        } else {
          matchmaker.removeClass('has-entry-active');
        }

        this.dotsAnimation(matchmaker);

        if (!active.find('.js-matchmaker-inner-copy').length) {
          const innerCopy = this.prev
            .find('.js-matchmaker-inner')
            .clone()
            .removeClass('js-matchmaker-inner')
            .addClass('js-matchmaker-inner-copy c-matchmaker__inner--copy');

          active.append(innerCopy);
        }
      });
    });
  }
}

export default new MatchmakerSlider();



// WEBPACK FOOTER //
// ./src/scripts/modules/matchmaker-slider.js